var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_1265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 72.8398L37.4022 83.6985L63.6675 72.8398C63.6675 70.6747 63.4925 68.4389 62.2711 66.6511C61.1846 65.0608 59.4502 63.38 56.8932 62.4997C52.5232 60.9952 46.2071 57.1865 43.5953 55.4701V48.5302C44.64 47.2466 46.7563 43.9632 46.8638 41.0977C48.207 40.0679 50.4367 37.3188 48.61 34.5607C47.9941 33.6309 48.2502 31.6609 48.5598 29.2794C49.198 24.3696 50.1498 16.0563 43.5953 16.0563C41.2102 13.8835 39.4916 13.364 36.0002 13.364C21.3718 13.364 22.6024 22.8304 23.4407 29.2794C23.7503 31.6609 24.0064 33.6309 23.3905 34.5607C21.5637 37.3188 23.7935 40.0679 25.1367 41.0977C25.2442 43.9632 27.3605 47.2466 28.4052 48.5302V55.4701C25.7934 57.1865 19.4773 60.9952 15.1073 62.4997C12.5502 63.38 10.8159 65.0608 9.72939 66.6511C8.50799 68.4389 8.33301 70.6747 8.33301 72.8398Z",
    fill: "#C4C7D1"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 71,
    height: 72,
    rx: 7.5,
    stroke: "#C4C7D1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_1265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 73,
    rx: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.dbd0799943247a013fcfa47c0f19247a.svg";
export { ForwardRef as ReactComponent };